export class AttendanceHourService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    /**
     * Add or update and attendance hour to an application
     * @param attendanceHour
     */
    async set(attendanceHour) {
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `postmaster@desk.${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.iris.desk.attendance-hour-container+json',
            uri: '/attendance-hour',
            resource: attendanceHour,
        });
    }
}
AttendanceHourService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
